import { Metadata } from "next";
import { PRIMARY_DOMAIN } from "apps/website/constants/website";

const TRACKING_PARAM_NAMES = new Set([ "discount_code", "situation", "postLogin", "_gl" ]);

export const isTrackingParam = (key: string): boolean => TRACKING_PARAM_NAMES.has(key) || key.startsWith("utm_");

export type CanonicalQuery = Record<string, string | string[] | undefined>;

export const buildCanonicalUrl = (path: string, query?: CanonicalQuery): string => {
  const [ pathname ] = path.split(/[?#]/);
  const cleanedPath = pathname
    .replace(/^\/+/, "")
    .split("/")
    .map(encodeURIComponent)
    .join("/");

  const params = new URLSearchParams();
  Object.entries(query ?? {}).forEach(([ key, value ]) => {
    if (value === undefined || isTrackingParam(key)) {
      return;
    }
    (Array.isArray(value) ? value : [ value ]).forEach((entry) => params.append(key, entry));
  });
  const search = params.toString();
  const querySuffix = search ? `?${search}` : "";

  return `${PRIMARY_DOMAIN}/${cleanedPath}${querySuffix}`;
};

export const buildSlugPath = (...segments: (string | undefined)[]): string => {
  const cleaned = segments.filter((segment): segment is string => Boolean(segment));
  return cleaned.length ? `/${cleaned.join("/")}` : "/";
};

export const getJoinedSlug = (slug: string[] | undefined): string => {
  if (Array.isArray(slug)) {
    return slug.join("/");
  }
  return slug ?? "";
};

export const buildCanonicalMetadata = (
  path: string,
  overrides?: Metadata,
  query?: CanonicalQuery,
): Metadata => ({
  ...overrides,
  alternates: {
    ...overrides?.alternates,
    canonical: buildCanonicalUrl(path, query),
  },
});
